module.exports = __webpack_public_path__ + "static/media/20190301_Fiche_Lauréat_Digisol.dd11431f.pdf";